import { joinPath } from '../../core/utils';
import type { ImageVmBlockOptions, ImageVmPaths } from './types';

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveImageVmPaths(prefix: string, options?: ImageVmBlockOptions): ImageVmPaths {
  const segment = options?.diskSegment ?? 'systemDisk';
  return {
    disk: joinPath(prefix, segment),
  };
}
